
//import logo from './logo.svg';
//import './App.css';
import Index from "./jsx";
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./css/style.css";
import { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_SECRET_KEY);


function App() {
	// useEffect (() => {
	// 	window.onkeydown = function(key){if(key.ctrlKey == true){key.preventDefault()}};
	// 	const handleContextmenu = e => {
	// 		e.preventDefault()
	// 	}
	// 	document.addEventListener('contextmenu', handleContextmenu)
	// 	return function cleanup() {
	// 		document.removeEventListener('contextmenu', handleContextmenu)
	// 	}
	//   }, [ ])
	return (
		<div className="App" id="app">
			<Elements stripe={stripePromise}>
				<Index />
			</Elements>
		</div>
	);
}

export default App;
